var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup863White(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.972,
    height: 35,
    viewBox: "0 0 34.972 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863",
    transform: "translate(404.653 -129.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3981",
    "data-name": "Path 3981",
    d: "M-387.162,164.707a17.525,17.525,0,0,1-17.491-17.514A17.488,17.488,0,0,1-387.2,129.707a17.471,17.471,0,0,1,17.523,17.446A17.51,17.51,0,0,1-387.162,164.707Zm11.919-8.361a15.045,15.045,0,0,0-1.8-20.295,15.117,15.117,0,0,0-20.812.537,15.019,15.019,0,0,0-1.225,19.753,17.316,17.316,0,0,1,11.9-4.661A17.317,17.317,0,0,1-375.243,156.345Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3982",
    "data-name": "Path 3982",
    d: "M-259.25,228.731a6.918,6.918,0,0,1-6.926-6.885,6.934,6.934,0,0,1,6.922-6.935,6.932,6.932,0,0,1,6.926,6.931A6.917,6.917,0,0,1-259.25,228.731Z",
    transform: "translate(-127.913 -78.704)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup863White);
export default __webpack_public_path__ + "static/media/Group 863-white.f67ae69b3ea434f61d30fab84bb6afcc.svg";
export { ForwardRef as ReactComponent };